<template>
  <div class="slider">
    <div class="main">
      <!-- 登录 -->
      <!-- <ul v-if="isUser"> -->
      <ul>
        <!-- <li>
          <router-link rel="opener" :to="{ path: '/shoppingCart' }">
            <span class="main-span">{{ count ? count : 0 }}</span>
            <span class="iconfont icon-gouwucheman"></span><br />
            <span>购物车</span>
          </router-link>
        </li> -->
        <li>
          <router-link rel="opener" :to="{ path: '/attention' }">
            <span class="iconfont icon-a-lujing157"></span><br />
            <span>我的关注</span>
          </router-link>
        </li>
        <li>
          <div class="downloadxp">
            <span class="iconfont icon-xiazai"></span><br />
            <a class="a1" href="https://wssmsgapache.g-part.cn/download/"
              >下载小佩</a
            >
          </div>
        </li>
        <li>
          <div @click="go('im')">
            <!-- <span class="main-span">{{ count ? count : 0 }}</span> -->
            <span class="iconfont icon-kefu"></span><br />
            <span>客服咨询</span>
            <!-- </router-link> -->
            <!-- </a> -->
          </div>
        </li>
        <li @click="backTop" class="flex">
          <div>
            <span>返回顶部</span>
          </div>
          <span class="iconfont icon-fanhuidingbu"></span>
        </li>
      </ul>
      <!-- 未登录 -->
      <!-- <ul v-else> -->
      <!-- <ul v-if="1 == 0">
        <li>
          <a href="/login">
            <span class="main-span">0</span>
            <span class="iconfont icon-gouwucheman"></span><br />
            <span>购<br />物<br />车</span></a
          >
        </li>
        <li>
          <a href="/login">
            <span class="main-span">0</span>
            <span class="iconfont icon-iconset0318"></span><br />
            <span>配<br />件<br />篮</span>
          </a>
        </li>
        <li>
          <i></i>
          <a href="/login">
            <span class="main-span">0</span>
            <span class="iconfont icon-a-lujing162"></span><br />
            <span>客<br />服<br />咨<br />询</span>
          </a>
        </li>
        <li @click="backTop">
          <span>返回<br />顶部</span>
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script>
import { clientIf } from '@/api/xiaopei/down'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
import { getgoodsdetails, rmCustomerService } from '@/api/xiaopei/index'
import { getCount } from '../../../api/home'
export default {
  name: 'slider',
  data() {
    return {
      isUser: this.$store.state.user.userData,
      count: ''
    }
  },
  methods: {
    // 购物车
    async getCount() {
      // if (this.isUser) {
      //   const res = await getCount({ userId: this.isUser.id })
      //   if (res.status == true) {
      //     this.count = res.data.count
      //   } else {
      //     this.$Message.error(res.message)
      //   }
      // } else {
      //   return
      // }
    },
    // 返回顶部
    backTop() {
      let scrollToptimer = setInterval(function() {
        let top = document.body.scrollTop || document.documentElement.scrollTop
        let speed = top / 4
        if (document.body.scrollTop != 0) {
          document.body.scrollTop -= speed
        } else {
          document.documentElement.scrollTop -= speed
        }
        if (top == 0) {
          clearInterval(scrollToptimer)
        }
      }, 30)
    },
    async go(type) {
      // return false
      let routeData = ''
      console.log(type)
      switch (type) {
        //   case 'message':
        //     routeData = this.$router.resolve({ path: '/platformMessage' })
        //     window.open(routeData.href, '_blank')
        //     break
        //   case 'car':
        //     routeData = this.$router.resolve({ path: '/shoppingCart' })
        //     window.open(routeData.href, '_blank')
        //     break
        case 'im':
          const res2 = await getgoodsdetails()
          console.log(res2)
          let url2 = res2.data.url
          let name = JSON.parse(localStorage.getItem('userData')).username
          // console.log(name)
          let token = Cookies.get(TOKEN_KEY)
          rmCustomerService({ oppositeTenantId: '' }).then(res => {
            console.log(res)
            let loginName = res.data.loginName
            if (res.status) {
              // getRmChat({ loginName: res.data.loginName }).then(res => {
              // console.log(res)
              clientIf(
                name,
                url2 + '/rm-order',
                res.data.userId,
                token,
                loginName
              )
              // })
            }
          })
          break
          if (!sessionStorage.getItem('userData')) {
            return this.$router.push('/login')
          }
          var kefuType = {
            // 客服组类型
            0: '综合',
            1: '译码',
            2: '订单',
            3: '财务',
            4: '售后',
            5: '物流',
            6: '第三方门店'
          }
          await deleteCount()
          getKefus({
            id: sessionStorage.getItem('userId'),
            storeCode: '00001',
            groupType: '0'
          }).then(res => {
            res.customerList =
              Array.isArray(res.customerList) &&
              res.customerList.filter(el => {
                return el.status != 0
              })
            if (!(res.customerList && Array.isArray(res.customerList))) {
              this.$message.warning('暂无客服人员!')
              return
            }
            kefus =
              res.customerList.map(el => {
                el.id = el.userId
                el.company = el.companyName
                el.storeName = el.companyName
                  ? el.companyName
                  : el.storeName
                  ? el.storeName
                  : '匿名企业'
                el.username = el.loginName
                el.fullname = kefuType[el.groupType] + '组' + el.userName
                if (el.avatar && el.avatar.length > 6) {
                  el.avatar = urlObj.endurl + el.avatar
                }
                return el
              }) || []
            let currkefuid = kefus[0].id
            sessionStorage.currkefuid = currkefuid
            if (!sessionStorage.kefus) {
              sessionStorage.setItem('kefus', JSON.stringify(kefus))
            } else {
              let hash = {}
              kefus = [...kefus, ...JSON.parse(sessionStorage.getItem('kefus'))]
              const data2 = kefus.reduce((preVal, curVal) => {
                hash[curVal.id]
                  ? ''
                  : (hash[curVal.id] = true && preVal.push(curVal))
                return preVal
              }, [])
              sessionStorage.setItem('kefus', JSON.stringify(data2))
            }
            if (localStorage.open) {
              localStorage.open = parseInt(localStorage.open) + 1
            } else {
              localStorage.open = 1
            }
            window.open(`${origin}/ims/font/im.html`, '_blank')
          })
          break
        default:
          break
      }
    }
  },
  created() {
    this.getCount()
  }
}
</script>

<style lang="less" scoped>
.slider {
  position: fixed;
  top: 0px;
  right: 0px;
  width: 30px;
  height: 100vh;
  text-align: center;
  z-index: 9999999;
  background-color: #818181;
  .main {
    position: relative;
    top: 20%;
    ul {
      // i {
      //   // margin: 17px 0;
      //   width: 24px;
      //   background-color: #ffffff;
      // }
      cursor: pointer;
      li {
        cursor: pointer;
        position: relative;
        color: #ffffff;
        width: 23px;
        margin: 0 4px;
        display: flex;
        justify-content: center;
        // align-items: center;
        border-bottom: 1px solid #ffffff;
        padding-bottom: 5px;
        padding-top: 5px;
        line-height: 13px;
        // cursor: pointer;
        span {
          font-size: 12px;
          cursor: pointer;
        }
        .main-span {
          cursor: pointer;
          width: 16px;
          height: 16px;
          // padding: 2px;
          line-height: 16px;
          background: #e90d0d;
          border-radius: 50%;
          color: #ffffff;
          font-size: 10px;
          position: absolute;
          top: -9px;
          left: -3px;
          z-index: 99;
        }
        .iconfont {
          font-size: 14px;
        }
        a > span {
          color: #ffffff;
          // font-size: 16px;
        }
        .downloadxp {
          width: 12px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 13px;
          color: #ffffff;
          .a1 {
            color: #ffffff;
          }
        }
      }
      .flex {
        display: flex;
        flex-direction: column;
        .icon-fanhuidingbu {
          margin-top: 5px;
        }
      }
      ul > li:nth-child(2) {
        padding: 54px 0;
        border-bottom: 1px solid #ffffff;
        // border-top: 1px solid #ffffff;
        // border: 1px solid #ffffff;
      }
      li:last-child {
        border-bottom: 0;
        // z-index: 99;
        // span {
        // font-size: 14px;
        // padding: 0 6px;
        // }
      }
    }
  }
}
</style>
